import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { fetchConsultant } from 'actions'
import { consultantNameSelector, consultantIsPendingSelector } from 'selectors'

import ConsultantInfo from './ConsultantInfo'
import Interests from './Interests'
import ExperienceComponent from './Experience'
import Spinner from 'components/Spinner'

const Wrapper = styled.div`
  padding: 8px;
  width: 100%;
  max-width: 950px;
  margin: 0 auto;
  display: grid;

  @media (min-width: 768px) {
    grid-template-columns: 290px 1fr;
    grid-gap: 20px;
  }
`

const Left = styled.div`
  width: 100%;
  margin-bottom: 8px;
  flex-shrink: 0;
`

const Experience = styled(ExperienceComponent)`
  min-width: 0;
`

class Consultant extends React.Component {
  componentDidMount = () =>
    this.props.fetchConsultant(this.props.consultantId, true)

  render() {
    if (this.props.isPending) return <Spinner />
    return (
      <Wrapper className={this.props.className}>
        <Left>
          <ConsultantInfo consultantId={this.props.consultantId} />
          <Interests consultantId={this.props.consultantId} />
        </Left>
        <Experience consultantId={this.props.consultantId} />
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, { consultantId }) => ({
  name: consultantNameSelector(state, consultantId),
  isPending: consultantIsPendingSelector(state, consultantId),
})

const mapDispatchToProps = { fetchConsultant }

export default connect(mapStateToProps, mapDispatchToProps)(Consultant)



// WEBPACK FOOTER //
// ./src/components/Consultant/index.js